export default function GuaranteeIcon() {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.3043 18.7398L23.4348 21.8703L29.6957 15.6094"
        stroke="#D48136"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1879 2.04349C29.247 1.36522 27.1705 1 25 1C14.6277 1 6.21719 9.41053 6.21719 19.7828C6.21719 30.1551 14.6277 38.5656 25 38.5656C35.3723 38.5656 43.7828 30.1551 43.7828 19.7828C43.7828 14.221 41.3619 9.22268 37.5219 5.77917"
        stroke="#505050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3425 41.7578L14.1999 48.9997L9.23289 42.29L0.999756 41.2987L5.96676 32.6064"
        stroke="#D48136"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6574 41.7578L35.8001 48.9997L40.7671 42.29L49.0002 41.2987L44.0332 32.6064"
        stroke="#D48136"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9756 30.0603C19.1878 31.7925 21.9739 32.8255 25 32.8255C32.2001 32.8255 38.0437 26.982 38.0437 19.7819C38.0437 12.5818 32.2001 6.73828 25 6.73828C17.8 6.73828 11.9564 12.5818 11.9564 19.7819C11.9564 21.6602 12.3529 23.4445 13.0625 25.0515"
        stroke="#505050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
